import { checkPermissions, useAuth } from "@elit-hair/elit-tools";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@elit-hair/elit-ui";
import { Icon } from "@elit-hair/elit-ui";
import { Link, useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { IconType } from "react-icons";
import { TbBuildingHospital, TbCalendar, TbClockHour4, TbMedicalCross, TbUsers } from "react-icons/tb";

import { APP_ROUTES } from "@/components/router/routes";
import { PERMISSIONS } from "@/constants/permissions";

type NavigationRoute = {
    path: string;
    title: string;
    icon: IconType;
    permissions?: string[];
};

const navigationRoutes: NavigationRoute[] = [
    {
        path: APP_ROUTES.ROOT,
        title: "sessions",
        icon: TbCalendar,
        permissions: [PERMISSIONS.PRP_SESSIONS_LIST],
    },
    {
        path: APP_ROUTES.CLINICS,
        title: "clinics",
        icon: TbBuildingHospital,
        permissions: [PERMISSIONS.TREATMENT_CLINICS_LIST],
    },
    {
        path: APP_ROUTES.STAFF,
        title: "staff",
        icon: TbUsers,
        permissions: [PERMISSIONS.TREATMENT_STAFF_LIST],
    },
    {
        path: APP_ROUTES.TREATMENTS,
        title: "treatments",
        icon: TbMedicalCross,
        permissions: [PERMISSIONS.TREATMENT_TREATMENT_LIST],
    },
    {
        path: APP_ROUTES.SHIFTS,
        title: "shifts",
        icon: TbClockHour4,
        permissions: [PERMISSIONS.TREATMENT_SHIFTS_CALENDAR],
    },
];

export function NavigationItems() {
    const { t } = useTranslation();
    const { state } = useSidebar();
    const routerState = useRouterState();
    const pathname = routerState.location.pathname;
    const { userData } = useAuth();

    return (
        <SidebarMenu>
            {navigationRoutes.map((route) => {
                if (!checkPermissions(userData?.permissionCodes, route.permissions)) {
                    return null;
                }

                const isCurrent = pathname === route.path;

                return (
                    <SidebarMenuItem key={route.path}>
                        <SidebarMenuButton
                            asChild
                            isActive={isCurrent}
                            tooltip={state === "collapsed" ? t(route.title) : undefined}
                        >
                            <Link to={route.path}>
                                <Icon icon={route.icon} size={20} />
                                <span>{t(route.title)}</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                );
            })}
        </SidebarMenu>
    );
}
